export const STORE_TYPE = 'asset-managers';